module.exports = __webpack_public_path__ + "img/lr-cb66-011.75f70fa5.gif";